import queryString from 'query-string';

export const resetURLParams = (params: string[]) => {
  const newUrl = queryString.exclude(window.location.href, params);
  window.history.replaceState({}, 'reset params', newUrl);
};

export default resetURLParams;
